import { combineReducers } from 'redux';
import cadReducer from './cadReducer';
export default combineReducers({
  cadReducer
});
